import { Component } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { RouterOutlet } from "@angular/router";
import { APP_NAME, APP_VERSION } from "@fuse/services/config/config.constants";
import { TranslocoModule } from "@jsverse/transloco";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  standalone: true,
  imports: [RouterOutlet, TranslocoModule],
  providers: [Title],
})
export class AppComponent {
  /**
   * Constructor
   */
  constructor(private readonly title: Title) {
    this.title.setTitle(`${APP_NAME} - ${APP_VERSION}`);
  }
}
